<template>
  <div>
    <Modal :title="title" v-model="show" width="700px">
      <div class="case-analysis-dialog">
        <div class="questions-item">
          <div
            class="item"
            v-for="(item, index) in analysisProcess.processVOS"
            :key="index"
          >
            <div class="head">
              <div class="tip fjcsb">
                <span>{{ item.processTitle }}</span>
                <span>{{ item.processTime }}</span>
              </div>
              <div class="employeeinfo">
                {{ item.employeeName }}（{{
                  common.valueToLabel(label1Type, item.label1)
                }}）
              </div>
            </div>
            <div class="body" v-if="item.processContent">
              <a
                v-if="item.processContentType == 2"
                :href="cloudPic(item.processContent, 'other')"
                target="_blank"
                class="questions"
              >
                <span>回复截图：</span>
                {{ item.processContent }}
              </a>
              <div v-else class="questions">
                <span v-html="item.processContent"></span>
              </div>
              <div v-if="item.carbonCopy" class="tip">
                抄送：{{ item.carbonCopy }}
              </div>
            </div>
            <div class="body b-empty" v-else></div>
          </div>
        </div>
        <empty
          v-if="
            !(analysisProcess.processVOS && analysisProcess.processVOS.length)
          "
          description="暂无数据"
        />
      </div>
      <template #footer>
        <span>
          <Button
            v-if="analysisProcess.reviewAnalysisButton"
            @click="openDetail(true)"
            >查看分析结果</Button
          >
          <!--
          <Button
            v-if="analysisProcess.uploadAnalysisButton"
            @click="openDetail(false)"
            >上传分析结果</Button
          >
          <Button
            v-if="analysisProcess.uploadExplainButton"
            @click="onSaveAnalysisExplain"
            >上传分析解释</Button
          > -->
        </span>
      </template>
    </Modal>
    <caseAnalysisDetail
      :patientCode="activeItem.patientCode"
      :taskInfo="activeItem"
      :showDialog="showDialog"
      @toggleHandle="showDialog = false"
      @analyzingReloadHandle="analyzingReloadHandle"
    />
    <!-- <saveAnalysisExplain
      ref="saveAnalysisExplainRef"
      :baId="baId"
      @success="getData"
    /> -->
  </div>
</template>

<script>
import caseAnalysisDetail from "./caseAnalysisDetail.vue";
// import saveAnalysisExplain from "./saveAnalysisExplain.vue";
// import { cloudPic } from "@/utils/cmzy.ts";
// import { valueToLabel } from "@/utils/cmzy";
import request from "@/utils/request";
export default {
  components: {
    caseAnalysisDetail,
    // saveAnalysisExplain,
  },
  data() {
    return {
      isLook: false,
      show: false,
      showDialog: false,
      activeItem: {},
      label1Type: [
        { label: "病程专家", value: 1 },
        { label: "医生", value: 4 },
        { label: "负责人", value: 6 },
        { label: "分析人", value: 66 },
      ],
      label2Type: [
        { label: "未回复", value: 0 },
        { label: "已回复", value: 1 },
      ],
      baId: "",
      analysisProcess: {},
    };
  },
  computed: {
    title() {
      return this.activeItem?.analysisResource == "3"
        ? "医闹病案分析"
        : "普通病案分析";
    },
  },
  methods: {
    onSaveAnalysisExplain() {
      this.$refs.saveAnalysisExplainRef.open();
    },
    onClose() {
      this.$refs.closeUserQuestionsRef.open();
    },
    onAnswer() {
      this.$refs.andwerUserQuestionsRef.open();
    },
    open(res) {
      this.activeItem = res;
      this.getData();
      this.show = true;
    },
    analyzingReloadHandle() {
      this.$bus.emit({
        type: "caseAnalysisDialog",
        data: "",
      });
      this.getData();
    },
    openDetail(look) {
      this.isLook = look;
      this.showDialog = true;
    },
    getData() {
      request
        .post("/saasbaihui/analysisProcess", {
          taskId: this.activeItem.taskId, //	Task_Id
          type: this.activeItem.type, //	1 百会病案分析 2 云诊病案分析
        })
        .then((res) => {
          let obj = res.result;
          this.analysisProcess = obj;
          if (obj.processVOS && obj.processVOS.length > 0) {
            this.baId = obj.processVOS[0].baId;
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.case-analysis-dialog {
  .questions-item {
    padding-bottom: 10px;
    margin-bottom: 15px;
    border-bottom: 1px solid #853a2f33;
    .item:last-child {
      .body {
        border-color: transparent;
      }
    }
    .head {
      padding: 10px 0;
    }
    .body {
      padding-left: 15px;
      margin-left: 15px;
      border-left: 2px solid #853a2f33;
      line-height: 2em;
      .questions {
        background-color: #ffffff66;
        padding: 5px 15px;
        border-radius: 5px;
      }
    }
  }
  .tip {
    font-size: 12px;
    opacity: 0.6;
  }
  .b-empty {
    height: 38px;
  }
}
</style>